// Hero secondary CTA — plain black text + down arrow (no pill, no circle)
// that glides to the eligibility section the way the homepage chapter nav
// does, instead of the browser's default hash jump.
"use client";

import { ArrowDown } from "iconoir-react";
import * as React from "react";

import { Link } from "@/components/ui/link/link";
import {
  isPlainLeftClick,
  smoothScrollToHash,
} from "@/lib/smooth-scroll-to-hash";
import { cn } from "@/lib/utils";

interface EligibilityScrollLinkProps {
  /** In-page target, e.g. `#restaurant-business-loans-eligibility`. */
  href: `#${string}`;
  className?: string;
  children: React.ReactNode;
}

export function EligibilityScrollLink({
  href,
  className,
  children,
}: EligibilityScrollLinkProps) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isPlainLeftClick(event)) return;
    event.preventDefault();
    smoothScrollToHash(href);
  };

  return (
    <Link
      href={href}
      external
      onClick={handleClick}
      className={cn(
        "text-grey-950 text-ds-label-lg group hover:text-grey-700 inline-flex items-center gap-1.5 py-1.5 font-medium transition-colors",
        className
      )}
    >
      {children}
      <ArrowDown
        aria-hidden
        className="size-4 transition-transform duration-[180ms] motion-safe:group-hover:translate-y-0.5"
        strokeWidth={2}
      />
    </Link>
  );
}
